import PropTypes from "prop-types";
import { Component } from "react";
import styles from "./styles/ToggleInput.module.scss";
import classNames from "classnames";
import { Switch } from "@radix-ui/themes";

export default class ToggleSwitch extends Component {
  static propTypes = {
    on: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    enabled: PropTypes.bool,
    wrapperClassName: PropTypes.string,
  };

  static defaultProps = {
    enabled: true,
  };

  render() {
    const { on, onClick, enabled, wrapperClassName, ...restProps } = this.props;

    const switchClassName = classNames({
      [styles.switch]: true,
      [wrapperClassName]: wrapperClassName,
    });

    return (
      <div className={switchClassName}>
        <Switch
          checked={on}
          onCheckedChange={onClick}
          disabled={!enabled}
          size={"3"}
          {...restProps}
        />
      </div>
    );
  }
}
